import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
// import { FiBook } from "react-icons/fi";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";

const StyledHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom: "1rem",
  paddingRight: "10px",
}));

const StyledCategoriesIcon = styled(CategoryOutlinedIcon)(({ theme }) => ({
  marginLeft: 16,
  fontSize: 24,
  color: theme.palette.primary.main,
  "&:hover": {
    cursor: "pointer",
  },
}));

const CategoriesHeader = () => {
  return (
    <StyledHeader>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 1,
          alignItems: "center",
          marginTop: 5,
        }}
      >
        <Typography
          ml={2}
          variant="h1"
          fontWeight={700}
          fontSize={26}
          sx={{ alignSelf: "flex-end" }}
          color="primary.main"
        >
          Categories
        </Typography>
        <StyledCategoriesIcon />
      </Box>
    </StyledHeader>
  );
};

export default CategoriesHeader;
